/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Content = styled.div`
  width: 650px;
  height: 620px;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 101;
  padding: 24px;
  padding-bottom: 0;
  gap: 24px;

  ::-webkit-scrollbar {
    width: 6px;
    background-color: #fff;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 8px;
  }
`;

const titleStyles = css`
  color: ${Palette.PrimaryGray._700};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  align-self: flex-start;
`;

const fieldStyles = css`
  display: flex;
  gap: 8px;
  text-align: left;
`;

export const Label = styled.label`
  ${titleStyles}
  width: 100%;
`;
export const Title = styled.p`
  ${titleStyles}
`;

export const Field = styled.div`
  ${fieldStyles}
  flex-wrap: wrap;
`;

export const ColumnField = styled.div`
  ${fieldStyles}
  flex-direction: column;
`;

export const LastColumnField = styled(ColumnField)`
  height: 100%;
  flex-grow: 1;
  overflow: hidden;
`;

export const UploadAnExample = styled.span`
  color: ${Palette.Primary._500};
  cursor: pointer;
`;

export const Text = styled.p`
  color: ${Palette.PrimaryGray._700};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  text-transform: none;
  text-align: left;
`;

//delete audience modal
export const Footer = styled.footer`
  display: flex;
  gap: 16px;
  background: ${() => Palette.PrimaryGray._000};
  padding: 16px 24px;
  width: 100%;

  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;

export const NotificationIcon = styled.div`
  background: ${Palette.Primary._500};
  width: 48px;
  height: 48px;
  font-size: 24px;
  color: #fff;
  font-weight: 600;
  line-height: 48px;
  display: flex;
  justify-content: center;
  border-radius: 50%;
`;

export const ModalDeleteTitle = styled.h3`
  color: ${Palette.PrimaryGray._900};
  text-align: left;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`;

export const ModalDeleteText = styled.p`
  text-transform: none;
  padding: 0;
  color: ${Palette.PrimaryGray._700};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;
